<template>
  <div>
    <div v-if="progress.background" class="vld-overlay is-active"
         style="z-index: 999; position: fixed; background: rgb(175 173 173 / 51%); backdrop-filter: blur(1px);"></div>
    <menu-pae/>

    <alert-comp :key="msgKey" :msg="msgAlert"/>

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item">
                <router-link to="/workArea">Home</router-link>
              </li>
              <li class="breadcrumb-item">A Receber</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>

    <div class="container mt-1">
      <alert-comp :center="true" v-if="progress.is" :key="progress.alertKey" :msg="progress.alert"
                  :dismissFunction="dismissFunction">
        <div v-for="processo in $store.getters.getDataTableChecked" :key="getKey(processo.data.atributos.numeroProcesso)">
          <span>{{ formatarProtocolo(processo.data.atributos.numeroProcesso) }}</span>
          <span v-if="isVisibleTryAgainReceber(processo.data.atributos.numeroProcesso)"  class="badge badge-info link" @click="receber(processo)">
            <i class="fa fa-refresh" aria-hidden="true"></i> Receber novamente
          </span>
          <span v-if="isVisibleTryAgainReceberAtribuir(processo.data.atributos.numeroProcesso)"  class="badge badge-info link" @click="tryAgainReceberAtribuir(processo.data.atributos.numeroProcesso)">
            <i class="fa fa-refresh" aria-hidden="true"></i> Receber/Atribuir novamente
          </span>
          <progress-bar
            :key="getKey(processo.data.atributos.numeroProcesso)"
            :percentage="getProgress(processo.data.atributos.numeroProcesso)"
            :danger="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
            :warning="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
            :success="`bg-${getStatus(processo.data.atributos.numeroProcesso)}`"
            :animated="true"
            class="mt-1 mb-3"
          />
        </div>
        <div class="col-12 text-right mb-2" v-if="progress.finished && processos.length !== progress.sucesso">
          <span class="badge badge-info text-left">Alguns protocolos não foram concluidos<br> Para aparecerem, tente novamente os protocolos com erro</span>
        </div>
      </alert-comp>
    </div>

    <div class="container-fluid mt-2">
      <filtro-pesquisa-a-receber
        class="p-2"
        :rowsNumber="10"
        :eventBusDataName="eventBusDataName"
        :eventBusPaginationName="eventBusPaginationName"
      />
    </div>

    <div class="container-xl">
      <data-table-consulta-comp
        :colNames="colNames"
        :eventBusDataName="eventBusDataName"
        :eventBusDataPaginationName="eventBusPaginationName"
        :renderizarCheckBox="true"
        :dataTableColumn="dataTableColumn"
        :colWidth="colWidth"
        :disableCheckbox="disableCheckbox"
        :subtable="subtable">
        <template v-slot:selectAll>
          <div v-on:click="toogleAll()">
            <i
              v-tooltip.auto-start="'Selecionar tudo'"
              v-if="toogle"
              class="fa fa-check-circle-o fa-2x link"
              aria-hidden="true"
            ></i>
            <i
              v-tooltip.auto-start="'Desmarcar tudo'"
              v-if="!toogle"
              class="fa fa-circle-o fa-2x link"
              aria-hidden="true"
            ></i>
          </div>
        </template>
        <template v-slot="slotProps">
          <td style="text-align: center; width: 100px !important; white-space: nowrap;">
            <i
              v-if="disableButton(slotProps.itemData)"
              v-tooltip.auto-start="`Visualizar Processo ${slotProps.itemData.processo}`"
              class="fa fa-search fa-1-5x m-1 link text-info"
              aria-hidden="true"
              v-on:click="visualizar(slotProps.itemData)"
            ></i>
            <i
              v-if="disableButton(slotProps.itemData)"
              v-tooltip.auto-start="`Imprimir Guia de Tramitação ${slotProps.itemData.ultimaTramitacao ? slotProps.itemData.ultimaTramitacao.lote : ''}`"
              class="fa fa-print fa-1-5x text-info m-1 link"
              aria-hidden="true"
              v-on:click="imprimirGuia(slotProps.itemData)"
            ></i>
          </td>
        </template>
        <template v-slot:subtable="subtable">
          <i
            v-tooltip.auto-start="`Visualizar protocolo ${subtable.itemData.data ? subtable.itemData.data.protocolo : ''}`"
            class="fa fa-search fa-1-5x link m-1 text-info"
            aria-hidden="true"
            v-on:click="visualizar(subtable.itemData.data)"
          ></i>
        </template>
      </data-table-consulta-comp>

      <div class="row btnAcoes">
        <button class="btn btn-outline-primary" @click.prevent="receberProtocolos()"> Receber</button>
        <button class="btn btn-outline-primary" @click.prevent="receberAtribuir()"> Receber / Atribuir</button>
        <button v-if="protocoloExternoIsVisible()" class="btn btn-outline-primary"
                @click.prevent="$refs.modalName.openModal()" type="button"> Protocolo Externo
        </button>
      </div>
    </div>

    <modal ref="modalName" width="1000px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="titulo">Protocolo Externo</h4>
          <i class="fa fa-times fa-1-5x" @click="$refs.modalName.closeModal()"/>
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body">
          <div class="alert alert-warning" role="alert">
            Utilize essa funcionalidade somente para dar recebimento aos protocolos que foram enviado para destinatários
            externos (Servidor, Pessoa Física ou Pessoa Jurídica).
          </div>
          <protocolo-externo/>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import filtroPesquisaAReceber from '@/components/consulta-processo/FiltroPesquisaAReceber.vue'
import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsulta'
import eventBus from '@/uteis/eventBus'
import modal from '@/components/shared/Modal.vue'
import protocoloExterno from '@/components/protocolo-externo/ProtocoloExterno.vue'
import alertComp from '@/components/alert/AlertComp'
import progressBar from '@/components/progressBar/ProgressBar'

import VirtusService from '@/services/VirtusService'
import VirtusRepositoryService from '@/services/VirtusRepositoryService'

import { componentIsVisible, rules } from '@/uteis/action/permissao'
import { protocoloParse } from '@/uteis/converters/ProtocoloConverter'

import { mapState } from 'vuex'

export default {
  name: 'receber',
  components: {
    menuPae,
    filtroPesquisaAReceber,
    dataTableConsultaComp,
    modal,
    protocoloExterno,
    alertComp,
    progressBar
  },

  data () {
    return {
      textError: '',
      msgKey: false,
      colNames: ['Remetente', 'Nº Protocolo', 'Tipo Protocolo', 'Assunto', 'Interessados', 'Data Envio', 'Ações'],
      eventBusDataName: 'consultaProcessoAReceber',
      eventBusPaginationName: 'consultaProcessoAReceberDataPagination',
      colWidth: [20, 10, 10, 20, 20, 10, 10],
      dataTableColumn: ['atributos.origem.titulo',
        {
          column: 'processo',
          converter: 'protocolo'
        },
        'atributos.tipoProtocolo',
        'atributos.assunto',
        {
          column: 'atributos.interessados.[nome]',
          converter: 'interessados'
        },
        {
          column: 'ultimaTramitacao.data',
          converter: 'localDate'
        }],
      subtable: {
        field: 'processosApensados',
        column: [
          {
            $set: 'Apenso'
          },
          {
            column: 'protocolo',
            converter: 'protocolo'
          },
          'tipoProtocolo',
          'assunto', {
            column: 'interessados.[nome]',
            converter: 'interessados'
          }
        ]
      },
      progress: {
        isAtribuir: false,
        is: false,
        background: false,
        finished: false,
        length: 0,
        sucesso: 0,
        alertKey: false,
        alert: {
          type: 'light',
          texto: 'Recebendo os protocolos:'
        },
        processos: {}
      },
      toogle: true
    }
  },

  computed: {
    ...mapState({
      filtroPesquisaAReceber: state => state.filtroPesquisaAReceber
    }),
    msgAlert () {
      return {
        type: this.textError === '' ? '' : 'danger',
        texto: this.textError === '' ? '' : this.textError
      }
    }
  },

  created () {
    this.service = new VirtusService()
    this.virtusRepositoryService = new VirtusRepositoryService()
  },

  methods: {
    dismissFunction () {
      this.progress.background = false
      this.progress.is = false
      this.limparSelecionados()
    },

    openModal (text) {
      const progress = {
        ...this.progress,
        isAtribuir: false,
        is: true,
        background: true,
        alertKey: !this.progress.alertKey,
        alert: {
          type: 'light',
          texto: text
        }
      }
      this.progress = progress
    },

    protocoloExternoIsVisible () {
      const { PROTOCOLO_EXTERNO } = rules
      return componentIsVisible(PROTOCOLO_EXTERNO)
    },

    isVisibleTryAgainReceberAtribuir (numeroProcesso) {
      if (!this.progress.isAtribuir) {
        return false
      }
      return this.getStatus(numeroProcesso) === 'danger'
    },

    isVisibleTryAgainReceber (numeroProcesso) {
      if (this.progress.isAtribuir) {
        return false
      }
      return this.getStatus(numeroProcesso) === 'danger'
    },

    getProgress (numeroProcesso) {
      const processo = this.progress.processos[numeroProcesso]
      return processo ? processo.porcentagem || '0%' : '0%'
    },

    getKey (numeroProcesso) {
      return `${numeroProcesso}-${this.getProgress(numeroProcesso)}`
    },

    getStatus (numeroProcesso) {
      const processo = this.progress.processos[numeroProcesso]
      return processo ? processo.status || 'info' : 'info'
    },

    formatarProtocolo (protocolo) {
      return protocoloParse(protocolo).value
    },

    limparSelecionados () {
      eventBus.$emit(this.eventBusPaginationName, 1, 'RESET_SELECTED')
    },

    visualizar (obj) {
      const processo = obj.processo ? obj.processo.replace(/\//g, '') : obj.protocolo.replace(/\//g, '')
      this.$router.push({
        name: 'visualizadorProcesso',
        query: { renderizaMenuProcesso: false, numeroProcesso: processo }
      })
    },

    atualizarProgress (numeroProcesso, obj) {
      this.progress.processos[numeroProcesso] = obj
      this.progress.alertKey = !this.progress.alertKey
    },

    async receberProtocolos () {
      const processos = this.$store.getters.getDataTableChecked
      this.openModal('Recebendo os protocolos:')

      for (const processo of processos) {
        const numeroProcesso = processo.data.atributos.numeroProcesso
        processo.data.processo = numeroProcesso
        if (this.getStatus(numeroProcesso) !== 'success') {
          await this.receber(processo)
        }
      }
    },

    async receberAtribuir () {
      const processos = this.$store.getters.getDataTableChecked

      this.progress = {
        ...this.progress,
        isAtribuir: true,
        is: true,
        background: true,
        alertKey: !this.progress.alertKey,
        alert: {
          type: 'light',
          texto: 'Recebendo/Atribuindo os protocolos:'
        }
      }

      for (const processo of processos) {
        const numeroProcesso = processo.data.atributos.numeroProcesso
        processo.data.processo = numeroProcesso
        if (this.getStatus(numeroProcesso) !== 'success') {
          await this.receber(processo, 25, 50)
          await this.atribuir(processo, 75, 100)
        }
      }
    },

    async tryAgainReceberAtribuir (processo) {
      const numeroProcesso = processo.data.atributos.numeroProcesso
      processo.data.processo = numeroProcesso
      if (this.getStatus(numeroProcesso) !== 'success' && this.getProgress(numeroProcesso) === '50%') {
        await this.receber(processo, 25, 50)
      }
      await this.atribuir(processo, 75, 100)
    },

    async receber (processo, min = 50, max = 100) {
      const dadosSessao = this.$store.getters.getDadosSessao
      const { sessao } = dadosSessao

      processo.data.processo = processo.data.atributos.numeroProcesso
      const { data: dadosDoProcesso } = processo
      try {
        this.atualizarProgress(dadosDoProcesso.processo, {
          porcentagem: `${min}%`,
          status: 'warning'
        })
        await this.service.receberProcessos(dadosDoProcesso, sessao)
        eventBus.$emit(this.eventBusPaginationName, 1)
        this.atualizarProgress(dadosDoProcesso.processo, {
          porcentagem: `${max}%`,
          status: 'success'
        })
      } catch (error) {
        eventBus.$emit(this.eventBusPaginationName, 1)
        this.atualizarProgress(dadosDoProcesso.processo, {
          porcentagem: `${max}%`,
          status: 'danger'
        })
        throw error
      }
    },

    async atribuir (processo, min = 75, max = 100) {
      const dadosSessao = this.$store.getters.getDadosSessao
      processo.data.processo = processo.data.atributos.numeroProcesso
      const sessaoDeUsuario = { ...dadosSessao.sessao }
      try {
        this.atualizarProgress(processo.data.processo, {
          porcentagem: `${min}%`,
          status: 'info'
        })
        await Promise.all([
          this.service.atribuirProcessos(processo, dadosSessao.sessao),
          this.service.registrarAtribuicaoNoHistorico(sessaoDeUsuario, dadosSessao.sessao, processo.data.processo)
        ])

        this.atualizarProgress(processo.data.processo, {
          porcentagem: `${max}%`,
          status: 'success'
        })

        eventBus.$emit(this.eventBusPaginationName, 1)
      } catch (error) {
        eventBus.$emit(this.eventBusPaginationName, 1)
        this.atualizarProgress(processo.data.processo, {
          porcentagem: '100%',
          status: 'danger'
        })
        throw error
      }
    },

    imprimirGuia (obj) {
      this.virtusRepositoryService
        .dowloadGuiTramite(obj.ultimaTramitacao.lote)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/pdf' })

          var filename = `guia${obj.ultimaTramitacao.lote}.pdf`

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob)
          } else {
            var fileURL = URL.createObjectURL(blob)
            window.open(fileURL, filename)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    disableCheckbox (protocolo) {
      if (!protocolo.data) {
        return false
      }

      return !this.isApensado(protocolo.data.atributos)
    },
    isApensado: (obj) => {
      if (!obj.atributos) {
        return false
      }
      return obj.apensadoEm && obj.apensadoEm !== ''
    },

    disableButton (obj) {
      if (!obj.atributos) {
        return false
      }

      return true
    },

    toogleAll () {
      const toogle = this.toogle
      this.toogle = !this.toogle

      if (!toogle) {
        this.$store.commit('MUT_KEY_TABLE_CHECKED', [])
        this.$store.commit('MUT_DATA_TABLE_CHECKED', [])
        return
      }

      this.service.consultarNoSetor({
        ...this.filtroPesquisaAReceber,
        offset: 1,
        range: 100000,
        _select: 'processo atributos.numeroProcesso atributos.assunto'
      }).then(res => {
        const dataTableChecked = []
        const keyTableChecked = []
        const data = res.data
        data.forEach((value, index) => {
          const key = value._id
          const data = []
          data.data = value
          keyTableChecked.push(key)
          dataTableChecked.push(data)
        })

        this.$store.commit('MUT_KEY_TABLE_CHECKED', keyTableChecked)
        this.$store.commit('MUT_DATA_TABLE_CHECKED', dataTableChecked)
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.interessadosHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: 0.75rem;
  background-color: rgba(213, 228, 251, 1);

  .titulo {
    color: #0962bd;
    margin: 10px;
  }

  i {
    color: red;
  }
}
</style>
